import Drawer from '@material-ui/core/Drawer';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {TOP_NAV_HEIGHT} from '../../util/constants';
import {DRAWER_WIDTH} from './constants';
import {WorkspaceTemplateContent} from './WorkspaceTemplateContent';
import {useWorkspaceTemplateDrawerContext} from './WorkspaceTemplateDrawerContextProvider';

const TRANSITION_DURATION = 500;

export const WorkspaceTemplateDrawer = () => {
  const {isWorkspaceTemplateDrawerOpen, closeWorkspaceTemplateDrawer} =
    useWorkspaceTemplateDrawerContext();

  return (
    <Drawer
      anchor="right"
      open={isWorkspaceTemplateDrawerOpen}
      onClose={closeWorkspaceTemplateDrawer}
      transitionDuration={TRANSITION_DURATION}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(13, 15, 18, 0.2)',
        },
      }}
      PaperProps={{
        style: {
          marginTop: `${TOP_NAV_HEIGHT}px`,
          height: `calc(100% - ${TOP_NAV_HEIGHT}px)`,
          width: DRAWER_WIDTH,
        },
      }}>
      <TailwindContents>
        <WorkspaceTemplateContent />
      </TailwindContents>
    </Drawer>
  );
};
